import { render, staticRenderFns } from "./modalBoton.vue?vue&type=template&id=333e04fb&"
import script from "./modalBoton.vue?vue&type=script&lang=js&"
export * from "./modalBoton.vue?vue&type=script&lang=js&"
import style0 from "./modalBoton.vue?vue&type=style&index=0&id=333e04fb&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports